export default "__VITE_ASSET__2578fa81__"